import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatGhs, formatItemPrice, isRangePriced } from '../../../utils/pricingUtils';

const AppointmentDetailsCard = ({ bookingData }) => {
  const { date, time, service, price, clientDetails } = bookingData || {};
  const hasRangePrice = isRangePriced(bookingData);

  const formatDate = (dateString) => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString)?.toLocaleDateString('en-US', options);
  };

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 border border-border shadow-sm animate-fade-in">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center">
          <Icon name="Calendar" size={24} color="white" />
        </div>
        <h2 className="font-heading font-semibold text-2xl text-foreground">
          Appointment Details
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex items-start gap-3 p-4 bg-gradient-to-br from-primary/5 to-secondary/5 rounded-lg border border-primary/20">
          <Icon name="Calendar" size={20} className="text-primary mt-1 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm text-muted-foreground font-caption mb-1">Date</p>
            <p className="font-caption font-semibold text-base text-foreground break-words">
              {formatDate(date)}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3 p-4 bg-gradient-to-br from-primary/5 to-secondary/5 rounded-lg border border-primary/20">
          <Icon name="Clock" size={20} className="text-primary mt-1 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm text-muted-foreground font-caption mb-1">Time</p>
            <p className="font-caption font-semibold text-base text-foreground">
              {time}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3 p-4 bg-gradient-to-br from-primary/5 to-secondary/5 rounded-lg border border-primary/20">
          <Icon name="Sparkles" size={20} className="text-primary mt-1 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm text-muted-foreground font-caption mb-1">Service</p>
            <p className="font-caption font-semibold text-base text-foreground break-words">
              {service}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3 p-4 bg-gradient-to-r from-primary/10 to-secondary/10 rounded-lg border border-primary/30">
          <Icon name="ReceiptCent" size={20} className="text-primary mt-1 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm text-muted-foreground font-caption mb-1">{hasRangePrice ? 'Price range' : 'Total Price'}</p>
            <p className="font-heading font-bold text-2xl text-primary">
              {hasRangePrice ? formatItemPrice(bookingData) : formatGhs(price)}
            </p>
            {bookingData?.requiresPriceFinalization && (
              <p className="mt-1 text-xs text-muted-foreground font-caption">The business will confirm the final price before payment.</p>
            )}
          </div>
        </div>
      </div>

      {clientDetails?.specialRequests && (
        <div className="mt-4 p-4 bg-muted/50 rounded-lg border border-border">
          <div className="flex items-start gap-2">
            <Icon name="MessageSquare" size={18} className="text-muted-foreground mt-0.5 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm text-muted-foreground font-caption mb-1">Special Requests</p>
              <p className="text-sm text-foreground font-caption">
                {clientDetails?.specialRequests}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppointmentDetailsCard;
